import React, { useState, useEffect } from 'react';
import { Modal, Button, Carousel, Badge } from 'react-bootstrap';
import { FaBolt, FaUserTie, FaWhatsapp, FaArrowRight, FaTimes, FaBarcode, FaTags, FaPalette } from 'react-icons/fa';
import packageJson from '../../../../../package.json';

// --- CONFIGURATION ---
const CURRENT_VERSION = packageJson.version;
const BRAND_COLOR = "#001c3a";
const ACCENT_COLOR = "#696cff";

const WhatsNewModal = () => {
    const [show, setShow] = useState(false);
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    useEffect(() => {
        // Check if user has seen this version's tour
        const savedVersion = localStorage.getItem('ishopmaster_version_seen');
        if (savedVersion !== CURRENT_VERSION) {
            // Add a small delay for smoother UX after login
            const timer = setTimeout(() => setShow(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleClose = () => {
        // Mark version as seen
        localStorage.setItem('ishopmaster_version_seen', CURRENT_VERSION);
        setShow(false);
    };

    const slides = [
        {
            icon: <FaBarcode size={40} className="text-primary" />,
            title: "POS Submission Fix",
            badge: "CORE FIX",
            desc: "Resolved the persistent 'shift id is missing' error during invoice submission. The POS will now accurately sync your shift data even on sudden page reloads.",
            bg: "linear-gradient(135deg, #E3F2FD 0%, #FFFFFF 100%)"
        },
        {
            icon: <FaPalette size={40} className="text-secondary" />,
            title: "Accessory Expansion",
            badge: "INVENTORY",
            desc: "Added new sub-categories! You can now properly categorize Smartwatch Protectors/Straps, LED/TikTok Lights, and Custom Back Stickers.",
            bg: "linear-gradient(135deg, #F3E5F5 0%, #FFFFFF 100%)"
        },
        {
            icon: <FaTags size={40} className="text-success" />,
            title: "Smart Categorization",
            badge: "UI/UX",
            desc: "Categories are now intelligently grouped with emoji headers. Find accessories, spare parts, and tools 10x faster with our new simplified layout.",
            bg: "linear-gradient(135deg, #E8F5E9 0%, #FFFFFF 100%)"
        }
    ];

    return (
        <>
            <style>
                {`
                    .feature-carousel .carousel-indicators { bottom: -40px; }
                    .feature-carousel .carousel-indicators button { background-color: ${BRAND_COLOR}; height: 4px; border-radius: 2px; }
                    .feature-modal .modal-content { border-radius: 20px; overflow: hidden; border: 0; }
                `}
            </style>

            <Modal show={show} onHide={handleClose} centered className="feature-modal" size="lg">
                <div className="d-flex">
                    {/* LEFT SIDE: Brand & Welcome */}
                    <div className="d-none d-md-flex flex-column justify-content-between p-4 text-white"
                        style={{ width: '35%', background: BRAND_COLOR, position: 'relative', overflow: 'hidden' }}>

                        {/* Background Deco */}
                        <div style={{ position: 'absolute', top: '-10%', right: '-10%', opacity: 0.1 }}>
                            <img src="/path/to/your/ism-icon-logo.png" alt="" width="200" />
                        </div>

                        <div>
                            <div className="fw-bold mb-1 opacity-75 small">iShopMaster</div>
                            <h3 className="fw-bold">What's New</h3>
                            <Badge bg="light" text="dark" className="mt-2 shadow-sm">v{CURRENT_VERSION}</Badge>
                        </div>

                        <div className="small opacity-75">
                            Upgrade your workflow with our biggest procurement update yet.
                        </div>
                    </div>

                    {/* RIGHT SIDE: Feature Slider */}
                    <div className="p-5 bg-white position-relative" style={{ width: '100%', minHeight: '400px' }}>
                        <Button
                            variant="link"
                            className="position-absolute top-0 end-0 m-3 text-muted p-0"
                            onClick={handleClose}
                        >
                            <FaTimes size={20} />
                        </Button>

                        <Carousel
                            activeIndex={index}
                            onSelect={handleSelect}
                            variant="dark"
                            className="feature-carousel h-100"
                            indicators={true}
                            controls={false}
                            interval={5000}
                        >
                            {slides.map((slide, i) => (
                                <Carousel.Item key={i} className="h-100">
                                    <div className="d-flex flex-column align-items-center text-center pt-4 h-100">
                                        <div className="mb-4 p-4 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                            style={{ width: '100px', height: '100px', background: slide.bg }}>
                                            {slide.icon}
                                        </div>
                                        <h4 className="fw-bold mb-2" style={{ color: BRAND_COLOR }}>{slide.title}</h4>
                                        <span className="text-uppercase x-small fw-bold text-muted mb-3 d-block tracking-wide">
                                            — {slide.badge} —
                                        </span>
                                        <p className="text-muted px-4" style={{ lineHeight: '1.6' }}>
                                            {slide.desc}
                                        </p>
                                    </div>
                                </Carousel.Item>
                            ))}
                        </Carousel>

                        {/* Custom Footer Navigation */}
                        <div className="d-flex justify-content-between align-items-center mt-5 pt-3">
                            <Button variant="link" className="text-muted text-decoration-none small" onClick={handleClose}>
                                Skip Tour
                            </Button>
                            <Button
                                variant="primary"
                                className="rounded-pill px-4 shadow-sm fw-bold d-flex align-items-center gap-2"
                                style={{ backgroundColor: ACCENT_COLOR, borderColor: ACCENT_COLOR }}
                                onClick={() => {
                                    if (index < slides.length - 1) setIndex(index + 1);
                                    else handleClose();
                                }}
                            >
                                {index === slides.length - 1 ? "Get Started" : "Next Feature"} <FaArrowRight size={12} />
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default WhatsNewModal;